import React, { useEffect, useState } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import ThinFooter from "../Footer/ThinFooter";
import ContentWrapper from "../Atomics/ContentWrapper/ContentWrapper";
import { HeadingWrapper } from "../Atomics/SectionHeader/SectionHeader";
import BasicTable from "../Atomics/Table";
import { accountUpgradeFetcher } from "../../api/requests";
import LoadingIndicator from "../Atomics/Loading/Loading";
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";
import { Button } from "react-bootstrap";
import Modal from "../Atomics/Modal";
import { useToaster } from "../../context/toaster";

const UserManagement = () => {
  const [usersData, setUsersData] = useState();
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState("users");
  const [userSave, setUserSave] = useState(false);
  const [showDelModal, setShowDelModal] = useState(false);
  const { addMessage } = useToaster();
  const [selectedRequest, setSelectedRequest] = useState(null);

  const showToast = (type, text) => {
    addMessage({
      id: Math.random().toString(36).substr(2, 9),
      type: type,
      text: text,
    });
  };

  const getUsersUpgradeData = async () => {
    setLoading(true);
    try {
      const res = await accountUpgradeFetcher.get();

      if (res.count > 0) setUsersData(res.results);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const getUsersData = async () => {
    setLoading(true);
    try {
      const res = await accountUpgradeFetcher.getUsers();

      if (res.count > 0) setUsersData(res.results);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleUserEdit = async () => {
    // setLoading(true);
    // try {
    //   const res = await accountUpgradeFetcher.editUsers(usersData);
    //   console.log(res);
    //   if (res.count > 0) setUsersData(res.results);
    // } catch (err) {
    //   console.error(err);
    // } finally {
    //   setLoading(false);
    // }
  };

  const handleDelApprove = async () => {
    try {
      const res = await accountUpgradeFetcher.deleteRequest(selectedRequest);
      setShowDelModal(false);

      if (res.message) showToast("success", "نظر با موفقیت حذف شد.");

      await getUsersUpgradeData();
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    if (activeTab === "upgrades") {
      getUsersUpgradeData();
    } else if (activeTab === "users") {
      getUsersData();
    }
  }, [activeTab]);

  return (
    <ContentWrapper>
      <Container
        fluid
        className="upload-details text-right"
        style={{
          paddingLeft: "30px",
          paddingRight: "30px",
          minHeight: "calc(100vh - 123px)",
        }}
      >
        <div
          style={{
            paddingTop: "30px",
            paddingLeft: "30px",
            paddingRight: "30px",
          }}
        >
          <Row>
            <Col>
              <div className="float-right">
                <HeadingWrapper heading="مدیریت کاربران" />
              </div>
            </Col>
          </Row>

          {/* {userSave && (
            <Row>
              <Col>
                <div className="float-right">
                  <Button
                    style={{
                      fontSize: "14px",
                      padding: "5px",
                      marginBottom: "15px",
                    }}
                    variant="success"
                    onClick={() => handleUserEdit()}
                  >
                    ذخیره
                  </Button>
                </div>
              </Col>
            </Row>
          )} */}

          <Row className="px-3 userTab">
            <Tabs
              id="user-management-tabs"
              activeKey={activeTab}
              onSelect={(k) => setActiveTab(k)}
              className="mb-3"
            >
              <Tab eventKey="users" title="کاربران">
                {loading ? (
                  <LoadingIndicator />
                ) : (
                  <BasicTable
                    cols={[
                      "verified",
                      "شناسه",
                      "تصویر",
                      "username",
                      "نام و نام خانوادگی",
                      "superuser",
                      "supervisor",
                      "staff",
                      "دسترسی",
                      "آخرین ورود",
                      "توضیحات",
                      "استان",
                      "شغل",
                      "تحصیلات",
                    ]}
                    rows={usersData}
                    name="users"
                    setUserSave={setUserSave}
                    setRows={setUsersData}
                  />
                )}
              </Tab>

              <Tab eventKey="upgrades" title="درخواست‌های ارتقاء">
                {loading ? (
                  <LoadingIndicator />
                ) : (
                  <BasicTable
                    cols={[
                      "ارتقاء",
                      "تاریخ",
                      "شناسه",
                      "تصویر",
                      "نام و نام خانوادگی",
                      "توضیحات",
                      "استان",
                      "شغل",
                      "تحصیلات",
                      "حذف",
                    ]}
                    rows={usersData}
                    name="userManagement"
                    setShowDelModal={setShowDelModal}
                    setSelectedRequest={setSelectedRequest}
                  />
                )}
              </Tab>
            </Tabs>
          </Row>
        </div>
      </Container>

      <Modal isOpen={showDelModal} onClose={() => setShowDelModal(false)}>
        <p style={{ paddingTop: "15px", fontSize: "18px", width: "100%" }}>
          از حذف این آیتم مطمئن هستید؟
        </p>
        <div style={{ display: "flex", gap: "5px", width: "100%" }}>
          <Button
            style={{
              fontSize: "15px",
              padding: "2px 8px",
              height: "fit-content",
            }}
            onClick={() => handleDelApprove()}
          >
            بله
          </Button>
          <Button
            style={{
              fontSize: "15px",
              padding: "2px 8px",
              height: "fit-content",
            }}
            variant="danger"
            onClick={() => setShowDelModal(false)}
          >
            خیر
          </Button>
        </div>
      </Modal>

      <ThinFooter />
    </ContentWrapper>
  );
};

export default UserManagement;
